module.exports = __webpack_public_path__ + "static/media/Spot_Terms_of_Use_CA.b2b4c5a3.pdf";